/* Surface-bound rollout lease. A fresh 45s lease is required; stale/missing control fails to Rebuy. */
(function(scope){
 'use strict';
 var MAX_LEASE=45000, POLL=10000;
 function valid(x,c,now){return !!x && x.schemaVersion===1 && x.surface===(c.surface||'byob') && x.epoch===c.epoch && x.themeId===c.themeId && x.source===c.source &&
  Number.isSafeInteger(x.revision) && x.revision>=0 && typeof x.enabled==='boolean' && [0,10,50,100].indexOf(x.percent)>=0 &&
  Number.isFinite(x.issuedAt) && Number.isFinite(x.expiresAt) && x.issuedAt<=now+1000 && x.issuedAt>now-MAX_LEASE && x.expiresAt>x.issuedAt && x.expiresAt-x.issuedAt<=MAX_LEASE && now<x.expiresAt;}
 function qa(source,role,search,surface){if(source!=='preview'||role!=='unpublished')return null;var v=new URLSearchParams(search).get(surface==='smart_cart'?'malezia_smart_cart_qa':'malezia_byob_qa');return ['native','rebuy'].indexOf(v)>=0?v:null;}
 function attributes(sid,c,decision,override){return {_mm_sid:sid,_malezia_rollout_sid:sid,_malezia_rollout_surface:'byob',_malezia_rollout_epoch:c.epoch,_malezia_rollout_provider:decision.provider,_malezia_rollout_source:c.source,_malezia_rollout_qa:override?'true':'false',_malezia_rollout_rules:c.rulesVersion};}
 // BYOB and existing preview consumers retain their prior lifecycle unchanged.
 function legacyCreate(c,onStop,io){
  io=io||{};var now=io.now||Date.now, fetcher=io.fetch||scope.fetch.bind(scope),lease=null,highest=-1,stopped=false,timer=null,expiry=null;
  function stop(reason){if(stopped)return;stopped=true;lease=null;if(timer)clearInterval(timer);if(expiry)clearTimeout(expiry);onStop(reason);}
  function current(){if(stopped||!valid(lease,c,now())||!lease.enabled||lease.percent===0)return null;return lease;}
  function url(){var u=new URL(c.controlUrl,scope.location.origin);if(u.protocol!=='https:'&&u.hostname!=='127.0.0.1')throw Error('protocol');
   if(u.origin!==scope.location.origin && u.hostname!=='cdn.shopify.com')throw Error('origin');
   // Shopify CDN keys this preview asset on v, not arbitrary query parameters.
   if(/\/malezia-(?:byob|smart-cart)-rollout-control\.json$/.test(u.pathname))u.searchParams.set('v',String(now()));
   u.searchParams.set('_lease_read',String(now()));return u.href;}
  async function refresh(){if(stopped)return null;try{
   var r=await fetcher(url(),{cache:'no-store',credentials:'omit',signal:AbortSignal.timeout(3000)});if(!r.ok)throw Error('status');var x=await r.json();
   if(!valid(x,c,now())||x.revision<highest)throw Error('invalid');
   highest=x.revision;lease=Object.freeze(x);
   if(!x.enabled||x.percent===0){stop('control-rebuy');return null;}
   if(expiry)clearTimeout(expiry);expiry=setTimeout(function(){stop('control-expired');},Math.max(0,x.expiresAt-now()));return x;
  }catch(_){stop('control-unavailable');return null;}}
  return {current:current,refresh:refresh,start:async function(){var x=await refresh();if(x&&!timer)timer=setInterval(refresh,POLL);return x;},stop:stop};
 }
 function create(c,onStop,io){
  if(c.surface!=='smart_cart')return legacyCreate(c,onStop,io);
  io=io||{};var now=io.now||Date.now, fetcher=io.fetch||scope.fetch.bind(scope),lease=null,highest=-1,stopped=false,timer=null,expiry=null,flight=null;
  function hidden(){return !!(scope.document&&scope.document.visibilityState==='hidden');}
  function stop(reason){if(stopped)return;stopped=true;lease=null;if(timer)clearInterval(timer);if(expiry)clearTimeout(expiry);onStop(reason);}
  function current(){if(stopped||!valid(lease,c,now())||!lease.enabled||lease.percent===0)return null;return lease;}
  function url(){var u=new URL(c.controlUrl,scope.location.origin);if(u.protocol!=='https:'&&u.hostname!=='127.0.0.1')throw Error('protocol');
   if(u.origin!==scope.location.origin && u.hostname!=='cdn.shopify.com')throw Error('origin');
   if(/\/malezia-(?:byob|smart-cart)-rollout-control\.json$/.test(u.pathname))u.searchParams.set('v',String(now()));
   u.searchParams.set('_lease_read',String(now()));return u.href;}
  function invalid(){var e=new Error('invalid-control');e.terminalControl=true;return e;}
  function armExpiry(){
   if(expiry)clearTimeout(expiry);
   expiry=setTimeout(function(){
    // A suspended tab has no usable expired authority. On return, refresh before
    // any action rather than treating normal browser suspension as provider failure.
    if(!hidden())refresh();
   },Math.max(0,lease.expiresAt-now()));
  }
  async function read(){
   for(var attempt=0;attempt<2&&!stopped;attempt++){
    try{
     var target;try{target=url();}catch(_){throw invalid();}
     var r=await fetcher(target,{cache:'no-store',credentials:'omit',signal:AbortSignal.timeout(3000)});
     if(!r.ok){if(r.status!==408&&r.status!==429&&r.status<500)throw invalid();throw Error('transport');}
     var x;try{x=await r.json();}catch(_){throw invalid();}
     if(!valid(x,c,now())||x.revision<highest)throw invalid();
     if(stopped)return null;
     highest=x.revision;lease=Object.freeze(x);
     if(!x.enabled||x.percent===0){stop('control-rebuy');return null;}
     armExpiry();return x;
    }catch(error){
     if(stopped)return null;
     if(error&&error.terminalControl){stop('control-unavailable');return null;}
     if(attempt===0){await new Promise(function(resolve){setTimeout(resolve,250);});continue;}
     // Never return cached authority as a successful fresh read. Routine callers
     // may continue only while the original unextended lease is still valid.
     if(!current()&&!hidden())stop(lease?'control-expired':'control-unavailable');
     return null;
    }
   }
   return null;
  }
  function refresh(){
   if(stopped)return Promise.resolve(null);
   if(flight)return flight;
   flight=read().then(function(x){flight=null;return x;},function(){flight=null;stop('control-unavailable');return null;});
   return flight;
  }
  return {current:current,refresh:refresh,start:async function(){var x=await refresh();if(x&&!timer)timer=setInterval(function(){if(!hidden())refresh();},POLL);return x;},stop:stop};
 }
 scope.MaleziaRolloutControl=Object.freeze({valid:valid,qa:qa,attributes:attributes,create:create,maxLeaseMs:MAX_LEASE,pollMs:POLL});
})(typeof window==='undefined'?globalThis:window);
